module.exports = __webpack_public_path__ + "img/logo-caveon-sm.9fe5c24b.png";